<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <v-row mt-3 no-gutters>
            <v-col cols="12" sm="8" md="9">
              <h1 class="headline">
                {{ $t('rent.title') }} -
                <a
                  v-if="userRole==='admin' || userRole==='rentManager'"
                  :href="`/autos/${credentials.carId}/info`"
                >
                  {{ autoTitle }}
                </a>
                <p v-else>{{ autoTitle }}</p>
              </h1>
              <p
                class="title"
                :class="{
                  'green--text': credentials.rentStatusId===IN_PROPGRESS_STATUS,
                  'grey--text': credentials.rentStatusId===END_STATUS,
                  'red--text': credentials.rentStatusId===END_BY_MANAGER_STATUS ||
                              credentials.rentStatusId===END_BY_DRIVER_STATUS ||
                              credentials.rentStatusId===AUTO_NOT_ACCEPTED_STATUS,
                }"
              >{{ rentStatus }}</p>
            </v-col>
            <v-col cols="12" sm="4" md="3" class="text-right">
              <v-btn
                v-if="credentials.rentStatusId && credentials.rentStatusId === IN_PROPGRESS_STATUS"
                @click="showRentCancelationDialog()"
                small
                color="warning"
              >
                {{ $t('rent.cancel.head.btn') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
      <v-row>
        <v-col cols="12" sm="8" md="8">
          <v-row no-gutters>
            <v-col cols="6" sm="4">{{ $t('rent.title.dateType') }}:</v-col>
            <v-col
              cols="6"
              sm="8"
              class="rentContent"
            >{{ rentDate }}</v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col cols="6" sm="4">{{ $t('rent.title.price') }}:</v-col>
            <v-col cols="6" sm="8" class="rentContent">{{ credentials.price }}</v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col cols="6" sm="4">{{ $t('rent.title.driverName') }}:</v-col>
            <v-col cols="6" sm="8" class="rentContent">
              <a
                v-if="userRole==='admin' || userRole==='cashManager'"
                :href="`/drivers/${credentials.driverId}/info`"
              >
                {{ credentials.name }}
              </a>
              <p v-else>{{ credentials.name }}</p>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-col cols="6" sm="4">{{ $t('rent.title.driverPhone') }}:</v-col>
            <v-col cols="6" sm="8" class="rentContent">
              {{ credentials.phone }}
              {{ credentials.secondPhone ? `, ${credentials.secondPhone}`: '' }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="4" md="4" class="text-right">
          <v-btn
            v-if="credentials.rentStatusId && credentials.rentStatusId!==AUTO_NOT_ACCEPTED_STATUS"
            color="#424242"
            class="ml-auto white--text"
            @click="downloadDoc()"
          >
            <v-icon right dark class="mr-1">mdi-text-box-outline</v-icon>
            {{ $t('rent.act.download') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-divider />
      <h3>{{ $t('rent.label.rentDetails') }}</h3>
      <photos-block :statePhotos="statePhotos" />
      <!-- Defects  -->
      <div v-if="defectComment || defectPhotos">
        <h3>{{ $t('rent.label.autoDefects') }}</h3>
        <p
          v-if="defectComment"
          class="font-italic font-weight-bold mb-0"
        >
          {{ defectComment }}
        </p>
        <v-row
          v-if="defectPhotos"
        >
          <v-col cols="12" class="d-flex flex-wrap">
            <div
              v-for="photo in defectPhotos" :key="photo.name"
              class="col-xl-2 col-md-3 col-sm-6 cols-12"
            >
              <div class="img-uploader">
                <image-uploader-new
                :photo.sync="photo"
                readonly
                outlined
              />
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
      <!-- Complectation  -->
      <div v-if="complectation">
        <h3>{{ $t('rent.label.complectation') }}:</h3>
        <v-row class="ml-2">
          <div
            v-for="item in complectation" :key="item"
            class="col-xl-2 col-md-3 col-sm-6 cols-12 pa-0"
          >
            <p class="subtitle-2">{{ $t(`rent.complectation.${item}`) }}</p>
          </div>
        </v-row>
      </div>
      <div
        v-if="refuseComment || refusePhoto"
      >
        <!-- Refuse reason  -->
        <v-divider />
        <h3>{{ $t('rent.label.refuseComment') }}:</h3>
        <p
          v-if="refuseComment"
          class="font-italic font-weight-bold mb-0"
        >
          {{ refuseComment }}
        </p>
        <v-row
          v-if="refusePhoto"
        >
          <v-col cols="12" class="d-flex flex-wrap">
            <div
              v-for="photo in refusePhoto" :key="photo.name"
              class="col-xl-2 col-md-3 col-sm-6 cols-12"
            >
              <div class="img-uploader">
                <image-uploader-new
                :photo.sync="photo"
                readonly
                outlined
              />
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
      <div
        v-if="credentials.rentStatusId === AUTO_NOT_ACCEPTED_STATUS && previousDriver"
      >
        <v-row no-gutters class="mt-2">
          <v-col cols="6" sm="4">{{ $t('rent.title.previousDriverName') }}:</v-col>
          <v-col cols="6" sm="8" class="rentContent">{{ previousDriver.name }}</v-col>
        </v-row>
        <v-row no-gutters class="mt-4">
          <v-col cols="6" sm="4">{{ $t('rent.title.previousDriverPhone') }}:</v-col>
          <v-col cols="6" sm="8" class="rentContent">
            {{ previousDriver.phone }}
            {{ previousDriver.secondPhone ? `, ${previousDriver.secondPhone}`: '' }}
          </v-col>
        </v-row>
      </div>
    </v-flex>
    <v-dialog
      transition="slide-y-transition"
      v-model="errorDialog"
      max-width="570"
      @keydown.esc="close"
    >
      <v-card class="confirm-dialog">
        <v-card-title>
          <div
            class="text-center modal-head-label"
          >
            {{ $t('rent.cancel.error') }}
          </div>
        </v-card-title>
        <v-card-actions>
          <v-layout align-center justify-center class="btns-wrapper mt-4 mb-4">
            <v-btn
              @click="errorDialog=false"
            >{{ $t('common.btns.close') }}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      transition="slide-y-transition"
      v-model="rentCancelationDialog"
      max-width="570"
      @keydown.esc="close"
    >
      <v-card class="confirm-dialog">
        <v-card-title>
          <div
            class="text-center modal-head-label"
          >
            {{ $t('rent.cancel.title') }}
          </div>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12">
              <v-textarea
                v-model="cancelationReason"
                ref="cancelReasonField"
                outlined
                :label="$t('common.fields.cancelationReason') + '*'"
                :rules="cancelationReasonRule"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col
              v-if="cancelationError"
              cols="12"
            >
              <v-label color="red">{{ cancelationError }}</v-label>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-layout align-center justify-center class="btns-wrapper mt-4 mb-4">
            <v-btn
              @click="rentCancelationDialog=false"
            >{{ $t('common.btns.cancel') }}</v-btn>
            <v-btn
              type="button"
              :disabled="areBtnsDisabled"
              class="warning ml-3"
              @click="cancelRent()"
            >{{ $t('common.btns.save') }}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { saveAs } from 'file-saver';
import { base64StringToBlob } from 'blob-util';
import DateHelper from '@/helpers/dateHelper';
import PhotosBlock from '@/components/rent/PhotosBlock.vue';
import ImageUploaderNew from '@/components/shared/ImageUploader.vue';

export default {
  name: 'RentPage',
  components: {
    PhotosBlock,
    ImageUploaderNew,
  },
  data() {
    return {
      IN_PROPGRESS_STATUS: 1,
      END_STATUS: 2,
      END_BY_MANAGER_STATUS: 3,
      END_BY_DRIVER_STATUS: 4,
      AUTO_NOT_ACCEPTED_STATUS: 5,
      areBtnsDisabled: false,
      id: null,
      autoTitle: null,
      rentStatus: null,
      rentDate: null,
      statePhotos: {},
      defectComment: null,
      defectPhotos: null,
      complectation: null,
      refuseComment: null,
      refusePhoto: null,
      previousDriver: null,
      credentials: {},
      isLoading: true,
      errorDialog: false,
      rentCancelationDialog: false,
      cancelationReason: null,
      cancelationReasonRule: [
        (v) => !!v || this.$t('common.fields.validation.field.required'),
        (v) => /^.{0,300}$/.test(v) || this.$t('common.fields.validation.cancelationReason'),
      ],
      cancelationError: null,
    };
  },
  computed: {
    ...mapGetters({
      rentTypes: 'rent/getRentsTypes',
      rentStatues: 'rent/getRentsStatuses',
      userRole: 'global/getRole',
    }),
  },
  watch: {
    '$route.params.rentId': function(newVal) {// eslint-disable-line
      this.loadData();
    },
  },
  async created() {
    await this.loadData();
  },
  methods: {
    ...mapActions({
      getRentDetails: 'rent/fetchRentDetails',
      getCarTitle: 'auto/fetchAutoTitle',
      getRentProperties: 'rent/fetchRentsProperties',
      getDriver: 'driver/fetchDriverData',
      downloadRentDoc: 'rent/downloadRentDocument',
      checkRentTransmitting: 'rent/checkRentTransmitting',
      completeRent: 'rent/cancelRent',
    }),
    async loadData() {
      this.isLoading = true;
      this.id = this.$route.params.rentId;
      try {
        await this.getRentProperties();
        const rentData = await this.getRentDetails(this.id);
        this.credentials = await this.prepareInputData(rentData);
        this.autoTitle = await this.getCarTitle({ id: this.credentials.carId });
        this.rentStatus = this.getRentStatus(this.credentials.rentStatusId);
        const rentFromDate = this.credentials.rentFrom.split(' ')[0];
        this.rentDate = `${DateHelper.prepareDateFromAPI(rentFromDate)} / ${this.getRentType(this.credentials.rentTypeId)}`;
      } catch (error) {
        if (error.status === 404) {
          this.$router.push({ name: 'not-found' });
        }
      }
      this.isLoading = false;
    },
    getRentStatus(statusId) {
      let rentStatus = '';
      this.rentStatues.forEach((status) => {
        if (status.id === statusId && status.table === 'rents') {
          rentStatus = status.title;
        }
      });
      return rentStatus;
    },
    getRentType(typeId) {
      let rentType = '';
      this.rentTypes.forEach((type) => {
        if (type.id === typeId) {
          rentType = type.title;
        }
      });
      return rentType;
    },
    async prepareInputData(rentData) {
      const outData = rentData;
      // get state photos
      this.statePhotos = this.prepareStateProtos(rentData.state.photo);
      if (rentData.state.defectComment && rentData.state.defectComment.comment) {
        this.defectComment = rentData.state.defectComment.comment.value;
      }
      if (rentData.state.defectPhoto && rentData.state.defectPhoto.length > 0) {
        this.defectPhotos = this.prepareStateProtos(rentData.state.defectPhoto);
      }
      // prepare complectation
      this.complectation = this.prerareComplectation(rentData.state.checkList);
      // refuse block
      if (rentData.state.refuseComment && rentData.state.refuseComment.comment) {
        this.refuseComment = rentData.state.refuseComment.comment.value;
      }
      if (rentData.state.refusePhoto && rentData.state.refusePhoto.length > 0) {
        this.refusePhoto = this.prepareStateProtos(rentData.state.refusePhoto);
      }
      // previous driver info
      if (rentData.previousDriverId) {
        const driver = await this.getDriver(rentData.previousDriverId);
        this.previousDriver = driver.data;
      }
      delete outData.state;
      return outData;
    },
    prepareStateProtos(statePhotos) {
      const outPhotos = {};
      Object.keys(statePhotos).forEach((key) => {
        outPhotos[key] = {
          name: statePhotos[key].value,
          link: statePhotos[key].link,
        };
      });

      return outPhotos;
    },
    prerareComplectation(checkList) {
      const outList = [];
      Object.keys(checkList).forEach((key) => {
        if (checkList[key].value === '1') {
          outList.push(key);
        }
      });
      return outList;
    },
    async downloadDoc() {
      const rentId = this.id;
      // download document process
      const response = await this.downloadRentDoc(rentId);
      const documentName = `${this.id}-${this.autoTitle}-act`;
      const blob = base64StringToBlob(response.file, 'application/vnd.openxmlformats-officedocument.wordprocessingml.document');
      saveAs(blob, `${documentName}.docx`);
    },
    async showRentCancelationDialog() {
      // check if rent on transmit-receive state
      const isRentTransmitting = await this.checkRentTransmitting(this.id);
      if (!isRentTransmitting) {
        this.errorDialog = true;
        return true;
      }
      // show rent cancelation dialog
      this.rentCancelationDialog = true;
      return true;
    },
    async cancelRent() {
      const field = this.$refs.cancelReasonField;
      if (field.validate()) {
        this.areBtnsDisabled = true;
        this.isLoading = true;
        // get cancelation reason
        const { cancelationReason } = this;
        const cancelData = {
          rentId: this.id,
          comment: cancelationReason,
        };
        const response = await this.completeRent(cancelData);
        if (response.success) {
          const rentData = await this.getRentDetails(this.id);
          this.credentials = await this.prepareInputData(rentData);
          this.rentStatus = this.getRentStatus(this.credentials.rentStatusId);
          this.cancelationReason = null;
          this.rentCancelationDialog = false;
          this.isLoading = false;
        } else {
          this.cancelationError = response.error.message;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rentContent {
  font-weight: 500;
}
h3 {
  margin-top: 15px;
  font-weight: 300;
}
.img-uploader {
  height: 220px;
}
.modal-head-label {
  word-break: break-word;
}
</style>
